var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GroupbuyingsList'
      }
    }
  }, [_vm._v(" 團購管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'BlacklistList'
      }
    }
  }, [_vm._v(" 逾期未取名單 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("查看紀錄")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("查看紀錄")])])]), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 d-flex items-center"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "src": _vm.customer.avatar_url
    }
  }), _vm._v(" " + _vm._s(_vm.customer.name) + " / " + _vm._s(_vm.customer.outer_code) + " ")])])]), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row mt-4 mb-3 justify-content-between"
  }, [_c('div', [_vm.checkPermission([_vm.consts.GROUPBUYING_BLACKLIST_REVOKE]) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.isBan
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v("解除停權")]) : _vm._e()], 1)]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.blacklists,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    staticClass: "separated",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.perPage,
      "aria-controls": "groupbuyList"
    },
    on: {
      "change": function change(page) {
        return _vm.fetchBlacklistHistories(page);
      }
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }